import { render, staticRenderFns } from "./operationRecords.vue?vue&type=template&id=4537dc14"
import script from "./operationRecords.vue?vue&type=script&lang=js"
export * from "./operationRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports